// extracted by mini-css-extract-plugin
export var actionIcon = "_tl-0";